// extracted by mini-css-extract-plugin
module.exports = {"dropdownIcon":"DropdownIcon_dropdownIcon__18lj3","open":"DropdownIcon_open__1TxI7"};